





























import { Component, Vue } from "vue-property-decorator";
import Axios from "axios";
import { serverBase } from "../../apollo";

@Component
export default class QueueInfo extends Vue {
  info = null as null | { isScanning: boolean; nextScanTimestamp: number | null };
  infoInterval = null as NodeJS.Timeout | null;
  folders: { images: string[]; videos: string[]; amount: number } = {
    images: [],
    videos: [],
    amount: 0,
  };

  get numFolders(): number {
    return this.folders.amount;
  }

  created() {
    this.getInfo();
    this.getFolders();
    this.infoInterval = setInterval(() => {
      this.getInfo();
    }, 5000);
  }

  destroyed() {
    if (this.infoInterval) {
      clearInterval(this.infoInterval);
    }
  }

  forceScan() {
    if (this.info?.isScanning) {
      return;
    }

    return Axios.post(serverBase + "/scan", null, {
      headers: {
        "X-PASS": localStorage.getItem("password"),
      },
    }).then(() => {
      if (this.info) {
        this.info.isScanning = true;
      }
      this.getInfo();
    });
  }

  async getFolders() {
    const res = await Axios.get(serverBase + "/scan/folders", {
      headers: {
        "X-PASS": localStorage.getItem("password"),
      },
    });
    this.folders = res.data;
  }

  async getInfo() {
    const res = await Axios.get(serverBase + "/scan", {
      headers: {
        "X-PASS": localStorage.getItem("password"),
      },
    });
    this.info = res.data;
  }
}
